export default __webpack_public_path__ + "static/media/pink.bbf01cbc.svg";